import { Avatar, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { getUser } from '/@/store/session/selectors';

const ProfileHeader = () => {
    const user = useSelector(getUser);

    return (
        <Stack
            className='mp-mask'
            spacing={2}
            direction='row'
            alignItems='center'
            p={2}
            pl={4}
            backgroundColor='#F5F5F5'
        >
            <Avatar
                sx={{
                    background: (t) => t.palette.primary.main,
                }}
            >
                <Typography variant='subtitle2' fontWeight='bold' color='white'>
                    {[user?.first_name?.charAt(0), user?.last_name?.charAt(0)].join('')}
                </Typography>
            </Avatar>
            <Typography variant='body1' color='primary'>
                {user?.first_name} {user?.last_name}
            </Typography>
        </Stack>
    );
};

export default ProfileHeader;
